import { useState, useEffect } from "react";
import initMenus from "../../data/menus.js";
import "./sidebar.css";
import MenuList from "./MenuList.jsx";
import { useNavigate, useLocation, NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";

function Sidebar({ className = "", toggle }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [filteredMenus] = useState(initMenus);
  const { logout: authLogout, user } = useAuth();
  const location = useLocation();

  const handleLogout = () => {
    toggle();
  };

  const confirmLogout = () => {
    authLogout();
    navigate("/login");
    toggle();
  };

  const cancelLogout = () => {
    toggle();
  };
  useEffect(() => {
    const iconPairs = [
      "home_white.svg",
      "home_red.svg",
      "search_white.svg",
      "search_red.svg",
      "notification_white.svg",
      "notification_red.svg",
    ];
    iconPairs.forEach((src) => {
      const img = new Image();
      img.src = `/${src}`;
    });
  }, []);

  useEffect(() => {
    if (user?.image) {
      const avatar = new Image();
      avatar.src = user.image;
    }
  }, [user?.image]);

  const LargeSidebar = ({ onLogout }) => (
    <aside className="hidden md:flex flex-col items-center justify-between bg-white dark:bg-dark-bg h-screen w-[250px] py-8 shadow-lg dark:shadow-dark-card border-r border-gray-200 dark:border-dark-border fixed left-0 top-0 z-40">
      {/* Top: Logo and App Name */}
      <div className="flex flex-col items-center gap-2">
        <div className="flex flex-col items-center">
          <Link to="/">
            <div className="bg-white dark:bg-transparent rounded-full p-2">
              <img 
                src="/logo-bg.png" 
                alt="VibeLinks Logo" 
                className="w-[80px] sm:w-[100px] object-contain" 
              />
            </div>
          </Link>
        </div>
      </div>
      {/* Middle: Only Feed, Search, Notification */}
      <div className="flex flex-col items-center gap-14 mt-16 flex-1">
        {[
          { to: "/home", label: "home", icon: "home" },
          { to: "/calendar", label: "menu.calander", icon: "calendar" },
          {
            to: "/notifications",
            label: "menu.notifications",
            icon: "notifications",
          },
          {
            to: "/settings",
            label: "menu.settings",
            icon: "settings",
          },
        ].map(({ to, label, icon }) => {
          const active = location.pathname === to;
          return (
            <NavLink
              key={to}
              to={to}
              // title={t(
              //   label,
              //   label === "notification" ? "Notification" : undefined
              // )}
              className="relative flex items-center justify-center"
            >
              <img
                src={`/${icon}${active ? "_blue.svg" : "_white.svg"}`}
                alt={label}
                width={30}
                height={30}
                className="w-[30px] h-[30px] block select-none"
                draggable={false}
              />
              {active && (
                <span
                  className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-2.5 h-2.5 bg-[#6D29F6] rounded-full ring-2 ring-white dark:ring-dark-bg"
                  aria-hidden="true"
                />
              )}
            </NavLink>
          );
        })}
        <NavLink
          to={`/profile`}
          title={t("profile", "Profile")}
          className="relative flex items-center justify-center shadow-xl rounded-full"
        >
          <div
            className="w-[47px] h-[47px] rounded-full border-2 dark:border-dark-border overflow-hidden flex-none flex items-center justify-center bg-gray-100 dark:bg-[#252739]"
            data-active={location.pathname === "/profile"}
          >
            <img
              src={user?.image || "/vibe_newlogo.png"}
              alt={user?.full_name || "profile"}
              width={47}
              height={47}
              draggable={false}
              className={`w-full h-full object-cover block select-none transition-[filter] ${
                location.pathname === "/profile" ? "" : ""
              }`}
            />
          </div>
        </NavLink>
      </div>
    </aside>
  );

  const SmallSidebar = ({ onLogout }) => (
    <aside
      id="sidebar"
      className={`sidebarWrapper md:hidden -translate-x-full z-40 no-scrollbar ${className} bg-primaryColor dark:bg-dark-bg flex flex-col`}
    >
      <div className="flex-1 overflow-y-auto">
        <MenuList menus={filteredMenus} toggle={toggle} onLogout={onLogout} />
      </div>
    </aside>
  );

  return (
    <>
      <LargeSidebar onLogout={handleLogout} />
      <SmallSidebar onLogout={handleLogout} />

      {className === "mobile" && (
        <div
          id="overlaySidebar"
          onClick={toggle}
          className="hidden absolute w-full h-screen bg-black z-[9999] inset-0 opacity-60"
        />
      )}
    </>
  );
}

export default Sidebar;
